import $ from 'jquery';
import { store } from '../redux/store'
import { close as closeMobileMenu, toggle as toggleMobileMenu } from '../redux/mobile-menu-slice'
import { setSubmenu1Slug } from '../redux/main-submenu-slice'
import { unfold as unfoldContactFloating, fold as foldContactFloating, toggle as toggleContactFloating } from '../redux/contact-floating-slice'
import { toggle as toggleMainSearchTextbox } from '../redux/main-search-textbox-slice'

/* Main menu desktop */
const initMainMenuDesktop =  () => {
    $('.main-menu-desktop ul li').each(function () {
        const jqLi = $(this)
        const jqA = jqLi.find('a')
        const slug = jqLi.data('slug')
        const hasChildren = jqLi.hasClass('has-children')
        if (slug && hasChildren) {
            jqA.on('click', function (event) {
                event.stopPropagation()
                event.preventDefault()
                store.dispatch(setSubmenu1Slug(slug))
                store.dispatch(foldContactFloating())
            })
        }
    })
}

/* Contacto */
const initContacto = () => {
    $('.main-menu-contacto a, .mobile .contact-button').on('click', function (event) {
        event.stopPropagation()
        const state = store.getState();
        if (state.mainSubmenu.submenu1Slug != '' || state.mobileMenu.open) {
            setTimeout(() => {
                store.dispatch(unfoldContactFloating())
            }, 300);
        } else {
            store.dispatch(toggleContactFloating())
        }
        store.dispatch(setSubmenu1Slug(''))
        store.dispatch(closeMobileMenu())
    })
}

/* Header mobile (includes Hamburger) */
const initHeaderMobile = () => {
    /* State vars */
    let isScrolledDown = false;
    let isMenuOpen = false;

    /* Elements */
    const headerMobileEl = document.querySelector('.main-header .mobile')
    const hamburgerEl = document.querySelector('.main-header-hamburger')

    /* Ensure elements exist */ 
    // if (headerMobileEl == null || hamburgerEl === null) return;

    /* Window scroll handler */
    const onDocumentScroll = (event) => {
        isScrolledDown = window.scrollY > 50
        updateHeaderMobile()
    }

    /* Update hamburger */
    const updateHamburger = () => {
        if (isMenuOpen) {
            hamburgerEl.classList.add('open');
        } else {
            hamburgerEl.classList.remove('open');
        }
    }

    /* Update header mobile */
    const updateHeaderMobile = () => {
        if (isScrolledDown || isMenuOpen) {
            headerMobileEl.classList.add('sticky-version')
        } else {
            headerMobileEl.classList.remove('sticky-version')
        }
    }
    
    /* Events */
    hamburgerEl.addEventListener('click', (event) => {
        event.stopPropagation()
        store.dispatch(toggleMobileMenu());
        store.dispatch(foldContactFloating())
    });
    window.addEventListener('scroll', onDocumentScroll)

    /* Redux mobileMenu */
    store.subscribe(() => {
        const state = store.getState();
        isMenuOpen  = !!state.mobileMenu.open
        updateHeaderMobile()
        updateHamburger()
    })

    /* Call some events at least once */
    onDocumentScroll()
};

/* Search */
const initSearch = () => {
    const searchButtonEl = document.querySelector('.main-header-search-button')
    if (searchButtonEl === null) return
    searchButtonEl.addEventListener('click', (event) => {
       event.stopPropagation() 
       store.dispatch(toggleMainSearchTextbox())
    })
}

/* Init everything on DOMContentLoaded */
document.addEventListener('DOMContentLoaded', () => {
    initMainMenuDesktop()
    initContacto()
    initHeaderMobile()
    initSearch()
})
